/**
 * Sanitize a string for use as a journey context variable name.
 * Lowercases and replaces non-alphanumeric/underscore characters with underscores.
 */
export const sanitizeVariableName = (variableName: string): string => {
  return variableName.toLowerCase().replace(/[^a-z0-9_]/g, "_");
};
